var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{attrs:{"compact":""}},[_c('H',{attrs:{"like":2}},[_vm._v("Gallery")]),(_vm.computedAreItemsLoading)?_c('Loading'):_vm._e(),_c('ul',{class:_vm.$style.ul},_vm._l((_vm.computedItems),function(ref,key){
var media = ref.media;
var title = ref.title;
return _c('li',{key:key,class:_vm.$style.li},[(media._linkType === 'Link.image')?_c('Img',{class:_vm.$style.img,attrs:{"data":media,"alt":title,"width":266,"height":266}}):_vm._e()],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }